<!--  -->
<template>
  <div style="padding: 20px;">
    <div>
      <el-date-picker
        v-model="parmrs.date"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        style="width: 300px;"
      />
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px;"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <div>
      <el-card shadow="never" class="summary-card">
        <div class="summary-container">
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.today }}总消耗</div>
            <div class="summary-value">{{ reportData.today_cost || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.today }}总回收</div>
            <div class="summary-value">{{ reportData.today_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.today }}总回收扣点</div>
            <div class="summary-value">{{ reportData.today_rebate_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.today }}总回收 ROI</div>
            <div class="summary-value">{{ reportData.today_roi || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.today }}总回收扣点 ROI</div>
            <div class="summary-value">{{ reportData.today_rebate_roi || 0 }}</div>
          </div>
        </div>

        <div class="summary-container">
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.yesterday }}总消耗</div>
            <div class="summary-value">{{ reportData.yesterday_cost || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.yesterday }}总回收</div>
            <div class="summary-value">{{ reportData.yesterday_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.yesterday }}总回收扣点</div>
            <div class="summary-value">{{ reportData.yesterday_rebate_income || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.yesterday }}总回收 ROI</div>
            <div class="summary-value">{{ reportData.yesterday_roi || 0 }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">{{ dateLabels.yesterday }}总回收扣点 ROI</div>
            <div class="summary-value">{{ reportData.yesterday_rebate_roi || 0 }}</div>
          </div>
        </div>
      </el-card>
      <el-card shadow="never">
        <div slot="header" style="font-weight: bold;">部门ROI统计</div>

        <el-table
          :data="real_time_department_data"
          border
          stripe
          style="width: 100%;"
        >
          <el-table-column prop="department_name" label="部门名称" width="180" align="center" />
          <el-table-column prop="cost" label="消耗" align="center" />
          <el-table-column prop="income" label="回收" align="center" />
          <el-table-column prop="roi" label="ROI" align="center" />
        </el-table>
      </el-card>
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" style="font-weight: bold;">投手ROI统计</div>

        <el-table
          :data="real_time_pitcher_data"
          border
          stripe
          style="width: 100%;"
        >
          <el-table-column prop="name" label="投手名称" width="150" align="center" />
          <el-table-column prop="cost" label="消耗" align="center" />
          <el-table-column prop="income" label="回收" align="center" />
          <el-table-column prop="roi" label="ROI" align="center" />
        </el-table>
      </el-card>
      <el-card shadow="never" style="margin-top: 20px;">
        <div slot="header" style="font-weight: bold;">剧集ROI统计</div>
        <el-table
          :data="short_launch_rank_data"
          border
          stripe
          style="width: 100%;"
        >
          <!-- <el-table-column prop="id" label="ID" width="80" align="center" /> -->
          <el-table-column prop="short_name" label="短剧名称" min-width="160" align="center" />
          <el-table-column prop="cost" label="消耗" align="center" />
          <el-table-column prop="income" label="回收" align="center" />
          <el-table-column prop="roi" label="ROI" align="center" />
        </el-table>
      </el-card>
      <!-- <pagination-right
        :current-page="parmrs.page"
        :page-sizes="[10]"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      /> -->
    </div>
  </div>
</template>

<script>
import { reportbigDataDashboardNative } from '@/api/TKreleaseGroup.js'
// import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { /* PaginationRight */ },
  data() {
    return {
      options: [],
      optionstwo: [],
      parmrs: {
        date: ''
      },
      dateRange: [],
      tableData: [],
      total: null,
      reportData: {},
      real_time_department_data: [],
      real_time_pitcher_data: [],
      short_launch_rank_data: [],
      dateLabels: {
        today: '',
        yesterday: ''
      }
    }
  },
  // computed: {
  //   dateLabels() {
  //     const today = this.formatDate(new Date())
  //     const selected = this.parmrs.date
  //     const isToday = selected === today

  //     if (isToday) {
  //       return {
  //         today: '今日',
  //         yesterday: '昨日'
  //       }
  //     } else {
  //       const selectedDate = new Date(selected)
  //       const prevDate = new Date(selectedDate)
  //       prevDate.setDate(selectedDate.getDate() - 1)
  //       return {
  //         today: this.formatDate(selectedDate),
  //         yesterday: this.formatDate(prevDate)
  //       }
  //     }
  //   }
  // },
  created() {

  },
  mounted() {
    // 设置默认日期为今天
    const today = new Date()
    const yyyy = today.getFullYear()
    const mm = String(today.getMonth() + 1).padStart(2, '0')
    const dd = String(today.getDate()).padStart(2, '0')
    this.parmrs.date = `${yyyy}-${mm}-${dd}`
    this.uyser()
    this.getlist()
  },
  methods: {
    search() {
      // this.parmrs.page = 1
      // 如果日期为空，使用今天的日期
      if (!this.parmrs.date) {
        const today = new Date()
        const yyyy = today.getFullYear()
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const dd = String(today.getDate()).padStart(2, '0')
        this.parmrs.date = `${yyyy}-${mm}-${dd}`
      }
      this.uyser()
      this.getlist()
    },
    uyser() {
      const today = this.formatDate(new Date())
      const selected = this.parmrs.date

      // 如果日期为空或无效，使用今天的日期
      if (!selected || selected === '') {
        this.dateLabels = {
          today: '今日',
          yesterday: '昨日'
        }
        return
      }

      const isToday = selected === today

      if (isToday) {
        this.dateLabels = {
          today: '今日',
          yesterday: '昨日'
        }
      } else {
        const selectedDate = new Date(selected)
        // 检查日期是否有效
        if (isNaN(selectedDate.getTime())) {
          this.dateLabels = {
            today: '今日',
            yesterday: '昨日'
          }
          return
        }
        const prevDate = new Date(selectedDate)
        prevDate.setDate(selectedDate.getDate() - 1)
        this.dateLabels = {
          today: this.formatDate(selectedDate),
          yesterday: this.formatDate(prevDate)
        }
      }
    },
    reset() {
      // 重置为今天的日期
      const today = new Date()
      const yyyy = today.getFullYear()
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const dd = String(today.getDate()).padStart(2, '0')
      this.parmrs.date = `${yyyy}-${mm}-${dd}`
      this.uyser()
      this.getlist()
    },
    getlist() {
      reportbigDataDashboardNative(this.parmrs).then((res) => {
        console.log(res)
        this.real_time_department_data = res.data.real_time_department_data
        this.real_time_pitcher_data = res.data.real_time_pitcher_data
        this.short_launch_rank_data = res.data.short_launch_rank_data
        this.reportData = res.data
        this.tableData = res.data.list
        this.total = res.data.count
      })
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.page_size = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      this.getlist()
    },
    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.summary-card {
  background-color: #f9fafc;
  margin-bottom: 10px;
  margin-top: 20px;
}
.summary-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.summary-item {
  flex: 1;
  min-width: 120px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  padding: 10px 15px;
  text-align: center;
}
.summary-label {
  font-size: 13px;
  color: #909399;
}
.summary-value {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin-top: 10px;
}
</style>
